<template>
  <div>
    <div class="table-scroll">
      <table class="table">
        <thead class="table-head">
        <tr>
          <th scope="col">Title</th>
          <th scope="col">Document</th>
          <th scope="col">Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="document in documents" :key="document.id">
          <td>{{ document.title }}</td>
          <td>
            <template v-if="isImage(document.attachment)">
              <img :src="getFileUrl(document.attachment)" alt="Preview" class="attachment-preview" />
            </template>
            <template v-else-if="isPdf(document.attachment)">
              <iframe :src="getFileUrl(document.attachment)" type="application/pdf" class="attachment-preview"></iframe>
            </template>
            <template v-else-if="isWord(document.attachment)">
              <iframe :src="`https://view.officeapps.live.com/op/embed.aspx?src=${getFileUrl(document.attachment)}`" class="attachment-preview"></iframe>
            </template>
            <template v-else>
              <a :href="getFileUrl(document.attachment)" target="_blank">View</a>
            </template>
          </td>
          <td>
            <button @click="downloadDocument(document.attachment)" class="btn btn-primary">Preview</button>
            <button @click="deleteDocument(document.id)" class="btn btn-danger">Delete</button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <create-document-modal @documentCreated="fetchDocuments"></create-document-modal>
  </div>
</template>

<script>
import CreateDocumentModal from './createDocumentModal.vue';

export default {
  components: {
    CreateDocumentModal,
  },
  data() {
    return {
      documents: [],
    };
  },
  created() {
    this.fetchDocuments();
  },
  methods: {
    fetchDocuments() {
      this.$axios({
        method  : "get",
        params  : {
          employee_id :  this.$store.getters.getEmployeeProfileId.id,
        },
        url     : this.$Documents,
        headers : this.getAuthHeader(),
      }).then((response) => {
        if (response.data.status == 200) {
          this.documents = response.data.result;
        }
      });
    },
    deleteDocument(documentId) {
      this.$axios({
        method  : "delete",
        url     : this.$Documents+'/'+documentId,
        headers : this.getAuthHeader(),
      }).then((response) => {
        if (response.data.status == 200) {
          this.fetchDocuments();
        }
      });
    },

    downloadDocument(filePath) {
      window.open(`${process.env.STORAGE_URL}${filePath}`, '_blank');
    },
    isImage(filePath) {
      return filePath.match(/\.(jpeg|jpg|gif|png)$/) != null;
    },
    isPdf(filePath) {
      return filePath.match(/\.pdf$/) != null;
    },
    isWord(filePath) {
      return filePath.match(/\.(doc|docx)$/) != null;
    },
    getFileUrl(filePath) {
      return `${process.env.STORAGE_URL}${filePath}`;
    }
  },

};
</script>
<style scoped>
/*.attachment-preview {
  width: 100px;
  height: 100px;
  object-fit: cover;
}*/
</style>
